import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getAllSubjectStart } from "../../redux/subject/reducer";
import { subjectList, subjectLoading } from "../../redux/subject/selectors";

const useSubjectsGet = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(subjectLoading);
  const subjects = useSelector(subjectList);
  const [curriculumType, setCurriculumType] = useState({
    label: "Curriculum Type",
    value: "",
  });
  const fetchSubjects = useCallback(() => {
    dispatch(getAllSubjectStart({ curriculum: curriculumType?.value }));
  }, [dispatch, curriculumType]);

  useEffect(() => {
    fetchSubjects();
  }, [fetchSubjects]);

  return {
    subjects,
    loadingSubjects: isLoading,
    curriculumType,
    setCurriculumType,
  };
};

export default useSubjectsGet;
